<!-- otp popup -->
<div *ngIf="application && application.IsMerchantCustomerLogin" id="otp-generator" class="modal otp-generator-modals"
  materialize="modal" [materializeParams]="[{dismissible: false}]">
  <form (ngSubmit)="verifyLoanAgreementOtp()">
    <div class="close-section right-align">
      <i class="material-icons" (click)="toggleOTPModal(false)">close</i>
    </div>
    <div class="modal-content">
      <p class="title center" *ngIf="phone" [textContent]="'Enter the OTP sent on ' + phone"></p>
      <input type="tel" name="otp_number" id="otp_number" maxlength="6" minlength="6" pattern="\d{6,6}"
        [(ngModel)]="otp_number" [textMask]="otpMask" autocomplete="off">
      <p class="resend-otp cursor-pointer center" *ngIf="remainingTime <= 0" (click)="resendLoanAgreementOtp()">Resend
        OTP</p>
      <p class="resend-otp center" *ngIf="remainingTime > 0">{{remainingTime}} s</p>
    </div>
    <div class="modal-footer">
      <button [disabled]="processing || !otp_number || (otp_number && otp_number.length != 6)"
        class="btn waves-effect zest-btn center">
        <span class="text-bold">I ACCEPT</span>
      </button>
    </div>
  </form>
</div>

<!-- insurance info -->
<zest-modal (onClear)="clearError($event)" (onConsentCheck)="getConsentValue($event)" *ngIf="insurancePartner"
  [modalHeader]="insuranceHead" [modalContent]="insuranceBody" [insurancePartner]="insurancePartner"
  [insuranceCheck]="insuranceCheck" [insuranceAmount]="insuranceAmount"
  [insuranceFeePercentage]="insuranceFeePercentage"></zest-modal>

<!-- Insurance Opt-out Confirmation Prompt -->
<div id="confirm-insurance-optout" class="modal new-modal" [class.bottom-sheet]="!isDesktop" materialize="modal">
  <div class="modal-content">
    <div class="header">
      <h2 class="title">Do you really want to opt-out of protection?</h2>
      <div class="close-btn" (click)="closeInsurancePopup('close')">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="main-modal-content loan-continue">
      <div class="modal-icon">
      </div>
      <div>
        An unfortunate accident, illness or injury can hamper your ability to repay. We have your back on this. Let your
        family be worry-free and enjoy the complete benefit of the loan.
        <br /><br />
        Do you still want to opt-out?
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn zest-btn outline" type="button" (click)="confirmInsuranceOptout(true)">YES</button>
    <button class="btn zest-btn primary" type="button" (click)="confirmInsuranceOptout(false)">NO</button>
  </div>
</div>

<!-- new code starts from here loan agreement-->
<div id="loanAgreementModal" class="modal loan-agreement-modal new-modal" [class.border-radius]="!isDesktop"
  [class.bottom-sheet]="!isDesktop" materialize="modal" [materializeParams]="[{dismissible: false}]">
  <div class="modal-content text-left">
    <!-- <div class="close-button" (click)="toggleAmountBreakupModal('close')">x</div> -->
    <div class="modal-title">
      <span class="bold"> <span class="insuranceAmount">₹ {{BasketAmount}}</span> </span> to be paid in next <span
        class="bold">{{NumberOfInstallments}} months </span>
    </div>
    <div class="download-link">
      <a href="#" (click)="startSanctionLetterDownload($event)">Download sanction letter</a>
    </div>
    <div class="content">
      <div class="col s6 m6 l6 row-titles">
        <div *ngIf="insurancePartner && insurancePartner.partnerName">
          <label class="checkbox">
            <span
              *ngIf="insurancePartner.partnerName.toLowerCase() !== 'acko'">
              I want to secure my loan at <span class="insuranceAmount">₹{{insuranceAmount}}</span> for personal
              accident & Critical illness with {{insurancePartner.partnerName.toUpperCase()}} insurance
              provider
              <span class="download-link"><a href="#"
                  (click)="getInsuranceDoc($event, insurancePartner.partnerName.toLowerCase())">Know more</a></span>
            </span>

            <span
              *ngIf="insurancePartner.partnerName.toLowerCase() === 'acko'">
              I agree to buy Insurance at <span class="insuranceAmount">₹{{insuranceAmount}}</span> and adhere to the
              terms of Acko GI.
              I hereby authorize Acko GI to make claim payment in favor of Zestmoney.
              <span class="tnc" (click)="getInsuranceDoc($event, insurancePartner.partnerName.toLowerCase())">Know
                more</span>
            </span>
            <input type="checkbox" [disabled]="processing" id="mycheckbox" name="mycheckbox" type="checkbox"
              [(ngModel)]="insuranceCheck" (ngModelChange)="checkInsuranceFacility()">
            <span class="checkmark"></span>
          </label>
        </div>

        <div *ngIf="downloadString && downloadString.length > 0 && lenderDetails">
          <label class="checkbox">
            If my loan is cancelled by <span [textContent]="lenderDetails.registeredName"></span> for any reason, I
            authorise ZestMoney to arrange a
            smilar loan from any other financial institution. I understand that the commercial terms of such loan will
            be similar to this loan
            <input type="checkbox" [disabled]="processing" id="consentCheckBox" name="consentCheckBox" type="checkbox"
              [(ngModel)]="authorizeLoanContext" (click)="saveAuthorizeContext($event)" (ngModelChange)="checkConsent()">
            <span class="checkmark"></span>
          </label>
        </div>
        <div *ngIf="showThirdPartyConsent">
          <label class="checkbox">
            <span>I hereby agree that ZestMoney has permission to share my personal information wherever it is necessary for the provision of loan products*</span>
            <span class="download-link" (click)="redirectToConsent()"> <a href="javascript:void(0);"> Read more</a></span>
             <input type="checkbox" id="thirdPartyConsentBox" name="thirdPartyConsentBox" type="checkbox"
               [(ngModel)]="thirdPartyConsent" (ngModelChange)="checkConsent()">
             <span class="checkmark"></span>
           </label>
        </div>
        <div *ngIf="showIncomeConsent">
           <label class="checkbox">
            <span> My household income is more than ₹25,000 per month. </span>
            <span class="download-link"><a href="javascript:void(0)"
                  (click)="triggerConsentModal('open')"> Know more</a></span>
            <input type="checkbox" id="incomeConsentBox" name="incomeConsentBox" type="checkbox"
              [(ngModel)]="incomeConsent" (ngModelChange)="checkConsent()">
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
    </div>
    <div>
      <p class="footer-content">By clicking on ‘Confirm purchase’ button, I agree to the terms and conditions of this
        <span class="download-link"><a href="#" (click)=showAgreementInfo($event)>loan agreement</a></span>
      </p>
      <button *ngIf="application && !application.IsMerchantCustomerLogin" [ladda]="processing"
        [disabled]="disableAcceptButton"
        [class]="processing?'btn waves-effect agreement-btn processing ladda-button margin-top-1rem':'btn waves-effect agreement-btn ladda-button margin-top-1rem'"
        (click)="saveLoanAgreement()">Confirm purchase</button>
      <button *ngIf="application && application.IsMerchantCustomerLogin" [ladda]="processing"
        [class]="processing?'btn waves-effect agreement-btn processing ladda-button margin-top-1rem':'btn waves-effect agreement-btn ladda-button margin-top-1rem'"
        (click)="triggerLoanAgreementOtp()">SEND OTP</button>
    </div>
  </div>
</div>

<!-- agreement info -->
<div id="agreementInfoModal" class="modal agreement-info-modal new-modal" [class.bottom-sheet]="!isDesktop"
  materialize="modal" [materializeParams]="[{dismissible: false}]">
  <div class="modal-content">
    <div class="fixed-header">
      <div class="header ">
        <h2 class="modal-title bold">Loan agreement
          <span *ngIf="emiHelpText">
            <br /><span class="emi-help-text" [innerHTML]="emiHelpText | safeHtml"></span>
          </span>
        </h2>
        <div class="close-btn" (click)="closeAgreementInfo($event)">
          <i class="material-icons">close</i>
        </div>
      </div>
      <div>
        <h4 class="sub-text">General terms & conditions of loan</h4>
      </div>
    </div>

    <div class="">
      <div class="agreement">
        <div class="agreement-text" [innerHTML]="loanAgreement | safeHtml"></div>
      </div>
    </div>
  </div>
</div>


<div id="incomeConsentModal" class="modal" materialize="modal" [materializeParams]="[{dismissible: true}]">
  <div class="modal-content consent-modal" *ngIf="contextJSON">
    <div class="close-btn" (click)="triggerConsentModal('close')">
      <i class="material-icons">close</i>
    </div>
    <img [src]="'https://assets.zestmoney.in/assets/customers/compliance-consents/Household+income.gif'" class="gif-banner-image" />
    <div class="modal-header" [textContent]="contextJSON.titleText"></div>
    <div class="modal-subheader" [textContent]="contextJSON.subtitleText"></div>
    <div class="content-data">
      <div *ngFor="let content of contextJSON.cardData; let j = index">
        <div [ngClass]="j==0 ? 'left-content' : 'right-content'">
          <img [src]="content.imageUrl" />
          <div class="content-header" [textContent]="content.title"></div>
          <div class="body" [textContent]="content.description">
          </div>
        </div>
      </div>
    </div>
    <div class="footer-data">
      <div class="footer-title" [textContent]="contextJSON.footer"></div>
      <div class="footer-body" [textContent]="contextJSON.description"></div>
    </div>
    <button class="footer-btn btn waves-effect zest-btn center" (click)="triggerConsentModal('close')">
        <span class="text-bold">Got it</span>
    </button>
  </div>
</div>